import { create } from 'zustand';

export interface UserStoreState {
  rents: any[];
  loading: boolean;
}

interface UserPhoneStoreActions {
  setUserRents: (user: UserStoreState) => void;
  setLoading: (state: boolean) => void;
}

interface UserStore {
  state: UserStoreState;
  actions: UserPhoneStoreActions;
}

export const useUserRentsStore = create<UserStore>((set) => ({
  state: {
    rents: [],
    loading: true,
  },
  actions: {
    setUserRents: (rents) => set({ state: rents }),
    setLoading: (load) =>
      set((state) => {
        return { state: { ...state.state, load } };
      }),
  },
}));
